import { colors, font } from '@/theme/zeelool.theme';
import { EPlatform } from '@/utils/enums/platform-enum';
import { Button } from '@mui/material';

interface RedeemButtonProps {
  deviceType: EPlatform;
  disabled?: boolean;
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'outlined' | 'contained';
  className?: string;
  sx?: object;
}

const RedeemButton = ({
  deviceType,
  disabled = false,
  children,
  onClick,
  variant = 'outlined',
  className,
  sx = {},
}: RedeemButtonProps) => {
  return (
    <Button
      variant={variant}
      disabled={disabled}
      onClick={onClick}
      className={className}
      sx={{
        width: '100%',
        height: deviceType === EPlatform.WEB ? '40px' : '28px',
        borderRadius: deviceType === EPlatform.WEB ? '20px' : '14px',
        borderColor: colors.auxiliaryDarkGray,
        fontSize: deviceType === EPlatform.WEB ? '16px' : '12px',
        fontFamily: font.bb,
        color: colors.primaryBlack,
        '&:hover': {
          backgroundColor: '#f9f9f9',
          color: colors.primaryBlack,
        },
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};

export default RedeemButton;
